import styles from './LikertGroup.module.css'

const SCALE_LABELS = ['SD', 'D', 'N', 'A', 'SA']

interface Props {
  itemId: string
  value: number | null
  onChange: (value: number) => void
  variant?: 'aqua' | 'magenta'
}

export function LikertGroup({ itemId, value, onChange, variant = 'aqua' }: Props) {
  return (
    <div className={`${styles.group} ${variant === 'magenta' ? styles.magenta : ''}`}>
      {[1, 2, 3, 4, 5].map(v => {
        const inputId = `radio_${itemId}_${v}`
        const checked = value === v
        return (
          <label key={v} className={styles.label} htmlFor={inputId}>
            <input
              type="radio"
              id={inputId}
              name={`item_${itemId}`}
              value={v}
              checked={checked}
              onChange={() => onChange(v)}
              className={styles.input}
            />
            <span className={`${styles.btn} ${checked ? styles.checked : ''}`}>{v}</span>
            <span className={styles.lbl}>{SCALE_LABELS[v - 1]}</span>
          </label>
        )
      })}
    </div>
  )
}
